import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import { Fade, makeStyles } from '@material-ui/core';
import ScopeGroup from './scopeGroup';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
  },
  scope: {
    width: '100%',
  },
}));

const ScopeGroups = ({
  translations = {},
  groups = [],
  hasActions = false,
  canAccessUserProfileCheck,
  onGoToUserProfile,
  onEditScope = () => {},
  onDeleteScope = () => {},
}) => {
  const classes = useStyles();

  return (
    <TransitionGroup className={classes.root}>
      {groups.map((group, index) => {
        return (
          <Fade key={`scope_group_${group.id}`} timeout={200}>
            <div className={classes.scope}>
              <ScopeGroup
                translations={translations}
                group={group}
                isFirstGroup={index === 0}
                hasActions={hasActions}
                canAccessUserProfileCheck={canAccessUserProfileCheck}
                onGoToUserProfile={onGoToUserProfile}
                onEdit={onEditScope}
                onDelete={onDeleteScope}
              />
            </div>
          </Fade>
        );
      })}
    </TransitionGroup>
  );
};

ScopeGroups.propTypes = {
  translations: PropTypes.object,
  groups: PropTypes.arrayOf(PropTypes.object),
  hasActions: PropTypes.bool,
  canAccessUserProfileCheck: PropTypes.func.isRequired,
  onGoToUserProfile: PropTypes.func.isRequired,
  onEditScope: PropTypes.func,
  onDeleteScope: PropTypes.func,
};

export default ScopeGroups;
export { ScopeGroup };
